import React, { useEffect, useState } from 'react'
import { toast } from 'react-toastify'
import axios from 'axios'
import { useNavigate, useParams } from 'react-router-dom'
import Footer from '../Footer'
import config from '../../function/config'
import Usernav from './Usernav'


export default function UserProfileUpdate() {
  const [username, setusername] = useState('')
  const [FirstName, setFirstName] = useState('')
  const [LastName, setLastName] = useState('')
  const [email, setEmail] = useState('')
  const [Phone, setPhone] = useState('')
  const [image, setImage] = useState('')
  const [Subscription_plan, setSubscription_plan] = useState('')
  const [ci, setCi] = useState('')  // Holds the current image URL
  const [loading, setLoading] = useState(false)

  const token = localStorage.getItem('token')
  const navigate = useNavigate()

  const { id } = useParams()


    useEffect(() => {
        if (!token) {
          navigate('/login'); // login page
        }
      }, [token, navigate]);

  useEffect(() => {
    async function fetchdata() {
      try {
        const res2 = await axios.get(
          `${config.base_url}/api/HappyMarineShipping/alluser`,
          {
            headers: {
              "Content-Type": "multipart/form-data",
              'Authorization': `Token ${token}`,
            },
          }
        );
        console.log("API response:", res2.data);
        if (res2.data.Status === 200) {
          setusername(res2.data.user.username)
          setEmail(res2.data.user.email)
          setPhone(res2.data.user.phone)
          setFirstName(res2.data.user.first_name)
          setLastName(res2.data.user.last_name)
          setSubscription_plan(res2.data.user.subscription_plan)
          setCi(`${config.base_url}${res2.data.user.image}`);  // Ensure the full URL for the current image
        } else {
          console.log(res2);
        }
      } catch (error) {
        console.log(error);
      }
    }
    fetchdata();
  }, [ token, id]);

 const handleSubmit = async () => {
  setLoading(true);

  const formData = new FormData();
  formData.append("username", username);
  formData.append("first_name", FirstName);
  formData.append("last_name", LastName);
  formData.append("email", email);
  formData.append("phone", Phone);
  formData.append("subscription_plan", Subscription_plan);
  if (image) {
    formData.append("image", image);
  }

  try {
    const response = await axios.put(
      `${config.base_url}/api/HappyMarineShipping/user/update`,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
          'Authorization': `Token ${token}`
        }
      }
    );

    if (response.data.status === 200) {
      setLoading(false);
      toast.success("User Updated Successfully!", {
        autoClose: 1500,
        position: 'top-right',
      });
    } else {
      setLoading(false);
      toast.error(response.data.message || "Something went wrong", {
        autoClose: 1500,
        position: "top-right",
      });
    }
  } catch (err) {
    setLoading(false);
    const errorMessage = err.response?.data?.message || "Error updating user";
    console.log("error", err.response?.data || err.message);
    toast.error(errorMessage, {
      autoClose: 2000,
      position: "top-right",
    });
  }
};

const [isSidebarOpen, setIsSidebarOpen] = useState(true);

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  const handleLogout = () => {
    localStorage.removeItem("token");
    navigate("/");
  };


  return (
        <div className="flex h-screen transition-all duration-300 ease-in-out">
      {/* Sidebar */}
      <div
        className={`bg-[#253356] text-white h-[100vh] overflow-hidden transition-all duration-300 ease-in-out ${
          isSidebarOpen ? "w-60 overflow-y-auto" : "w-0"
        }`}
      >
        <div className="p-5">
          <div className="flex justify-between items-center mb-6">
            <h2 className="text-xl font-bold">Mariniz</h2>
            <button
              onClick={toggleSidebar}
              className="text-2xl focus:outline-none"
            >
              <i className="fa-solid fa-bars"></i>
            </button>
          </div>

          <div className="py-3 mt-2">
            <img className="w-[80px] h-[80px] rounded-full" src={ci} alt="" />
          </div>

          <ul className="space-y-4 mt-3">
            <li
              onClick={() => navigate("/userHome")}
              className="hover:bg-[#d1a460] hover:transition-all hover:scale-105 hover:duration-300 p-2 hover:rounded-r-full hover:shadow-lg hover:font-semibold hover:text-[#253356] cursor-pointer"
            >
              Home
            </li>
            <li
              onClick={() => navigate("/userDashboard")}
              className="hover:bg-[#d1a460] hover:transition-all hover:scale-105 hover:duration-300 p-2 hover:font-semibold hover:rounded-r-full hover:shadow-lg hover:text-[#253356] cursor-pointer"
            >
              Dashboard
            </li>
            <li
              onClick={() => navigate("/userlist")}
              className="hover:bg-[#d1a460] hover:transition-all hover:scale-105 hover:duration-300 p-2 hover:rounded-r-full hover:shadow-lg hover:font-semibold hover:text-[#253356] cursor-pointer"
            >
              My Listing
            </li>
            <li
            onClick={()=>navigate('/userprofile')}
            className="bg-[#d1a460] transition-all scale-105 duration-300 p-2 rounded-r-full hover:shadow-lg font-semibold text-[#253356] cursor-pointer">
              Profile
            </li>
            <li
              onClick={handleLogout}
              className="hover:bg-[#d1a460] hover:transition-all hover:scale-105 hover:duration-300 p-2 hover:rounded-r-full hover:shadow-lg hover:font-semibold hover:text-[#253356] cursor-pointer"
            >
              Logout
            </li>
          </ul>
        </div>
      </div>

      {/* Main Content */}
      <div
        className={`transition-all duration-300 ease-in-out overflow-y-auto flex-1 px-5 py-2 bg-gray-100 ${
          isSidebarOpen ? "ml-0" : "w-full"
        }`}
      >
        <div className="flex items-center justify-between mb-6">
          {!isSidebarOpen && (
            <button
              onClick={toggleSidebar}
              className="text-2xl text-gray-600 focus:outline-none"
            >
              <i className="fa-solid fa-bars"></i>
            </button>
          )}
        </div>

        <div className="bg-white p-5 flex justify-between rounded-lg text-[#253356] font-semibold shadow">
          <p className="text-3xl">
            My{" "}
            <span className="text-[#d1a460] font-bold italic">Profile</span>
          </p>
          <button
            onClick={() => navigate("/regShip")}
            className="bg-[#253356] rounded-lg p-2 text-white"
          >
            New Listing +
          </button>
        </div>
        <section className=' bg-gray-100 mt-5  w-[100%]'>
        {/* login container */}
        <div className='signup    rounded-2xl shadow-lg p-5'> 
          {/* form */}
          <div className=' signup '>
          <div className='flex items-center gap-3'>
                  <img src={ci} alt="Current profile" className='w-[50px]  h-[50px]  rounded-full' />
            <h2 className='font-bold text-2xl text-[#002D74]'>Update Your Profile</h2>

              </div>

            <form action="" className='flex flex-col w-[100%]'>
              {/* username */}
              <label htmlFor="Username" className='mt-6 mb-2 font-bold text-xl '>Username</label>
              <input 
                className='p-2 rounded-xl ' 
                value={username} 
                name='username' 
                placeholder='Enter your Username' 
                type="text" 
                onChange={(e) => setusername(e.target.value)} 
              />

              {/* First Name and Last Name */}
              <div className='flex justify-between gap-3 items-center lg:flex-wrap mt-6 mb-2'>
                {/* First name */}
              <div className='flex flex-col  w-[50%]'>
                <label htmlFor="FirstName" className=' font-bold text-xl '>First Name</label>
                <input 
                  className='p-2 rounded-xl mt-1 w-full' 
                  value={FirstName} 
                  name='first_name' 
                  placeholder='Enter your First Name' 
                  type="text" 
                  onChange={(e) => setFirstName(e.target.value)} 
                />
              </div>

              {/* Last Name */}
              <div className='w-[50%] flex flex-col'>
              <label htmlFor="LastName" className=' font-bold text-xl '>LastName</label>
                <input 
                  className='p-2 rounded-xl mt-1 w-full' 
                  value={LastName} 
                  name='last_name' 
                  placeholder='Enter your LastName' 
                  type="text" 
                  onChange={(e) => setLastName(e.target.value)} 
                />
              </div>


              </div>

              {/* Email */}
              <label htmlFor="email" className='mt-6 mb-2 font-bold text-xl '>Email</label>
              <input 
                className='p-2 rounded-xl '
                value={email} 
                onChange={(e) => setEmail(e.target.value)} 
                name='email' 
                placeholder='Enter your Email' 
                type="email" 
              />
            
          {/* Phone */}
              <label htmlFor="phone" className='mt-6 mb-2 font-bold text-xl '>Phone</label>
              <input 
                className='p-2 rounded-xl '
                value={Phone} 
                onChange={(e) => setPhone(e.target.value)} 
                name='phone' 
                placeholder='Enter your mobile Number' 
                type="text" 
              />
              
              <label htmlFor="subscription_plan" className='mt-6 mb-2 font-bold text-xl '>Current Plan</label>
              <input 
                className='p-2 rounded-xl border border-gray-300'
                value={Subscription_plan} 
                // onChange={(e) => setSubscription_plan(e.target.value)} 
                disabled
                name='subscription_plan' 
                placeholder='' 
                type="text" 
              />
              
          {/* Image */}
              <div className='flex  items-center gap-4'>
                <label className='text-gray-400 font-bold' htmlFor="image">Image:</label>
                <input 
                  className='p-2 mt-4 rounded-xl' 
                  type="file" 
                  onChange={(e) => setImage(e.target.files[0])} 
                  name='image' 
                  id='image' 
                />
              </div>

              

              <button 
                onClick={(e) => { e.preventDefault(); handleSubmit() }} 
                className='bg-[#002D74] rounded-xl m-auto w-[50%] text-white py-2 mt-5 hover:scale-105 duration-300 hover:bg-[#3f649f] font-bold'>
                {
                  loading ? (
                    <span className='block w-[16px]  h-[16px] border-2 border-b-0 border-white mt-[4px] mb-[4px] rounded-full m-auto animate-spin'></span>
                  ) : (
                    "Update"
                  )
                }
              </button>
            </form>
          </div>
        </div>
      </section>
      </div>
    </div>
  )
}
